import {Route, Redirect} from "react-router-dom";

import {LOGIN_ROUTE} from "../lib/routes";
import {useAuth} from "../hooks/useAuthProvide";

export default function PrivateRoute({children, ...rest}) {
  const auth = useAuth();

  return (
    <Route
      {...rest}
      render={() => auth.user ? 
        (children) : 
        (<Redirect to={{pathname: LOGIN_ROUTE.path}} />)}
    />
  );
}
